export default () => {
    let groupDeleteModal = document.getElementById('groupDeleteModal');
    if (!groupDeleteModal) {
        return;
    }
    //todo finish delete modal
    //todo open redirect
    groupDeleteModal.addEventListener('show.bs.modal', function (event) {
        let button = $(event.relatedTarget);
        let email = button.data('email');
        let name = button.data('name');
        let action = button.data('action');
        let redirect = button.data('redirect');

        let modal = $(this);
        modal.find('#groupDelete').attr('action', action);
        modal.find('#email').val(email);
        modal.find('#name').val(name);
        modal.find('#redirect').val(redirect);
    });
};
